import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {AIIcon} from '../../icons/ai-icon';
import {CrossIconOld} from '../../icons/cross-icon';
import {ColorUtils} from '../../utils';
const LabelName = Styled.div`
	font-family: ${({theme}) => theme.fontFamily};
	position: relative;
	font-size: 10px;
	letter-spacing: 0.5px;
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0;
	margin: 0;
`;
const LabelContainer = Styled.div`
	box-sizing: border-box;
	max-width: calc(100% - 9px);

	height: 20px;
	margin-left: 9px;
	border-radius: 2px;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: ${props => props.backgroundColor};
	color: ${props => props.color};
	position: relative;
	display: inline-block;
	padding: 0 9px 0 2px;


	&::before {
		position: absolute;
		-webkit-transform: translateY(-50%) translateX(50%) rotate(-45deg);
		transform: translateY(-50%) translateX(50%) rotate(-45deg);
		top: 50%;
		right: 100%;
		content: '';
		background-color: inherit;
		width: 13px;
		height: 13px;
	}
`;

export const IconContainer = Styled.div`
	z-index: 1;
	padding-right: ${props => props.right && '5px'};
	padding-left:  ${props => props.left && '5px'};
`;

export const Content = Styled.div`
	z-index: 2;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 100%;
	width: 100%;
	padding-left: 5px;
`;

export const Label = ({color, name, onClick, showAI, onRemove}) => {
	const handleClick = () => {
		if (onClick) {
			onClick();
		}
	};

	return (
		<LabelContainer
			title={name}
			backgroundColor={color}
			color={ColorUtils.getInvertedTextColor(color)}
			onClick={handleClick}
		>
			<Content>
				{showAI && (
					<IconContainer right>
						<AIIcon size={AIIcon.SIZE.SMALL} color={ColorUtils.getInvertedTextColor(color)} opacity={0.5} />
					</IconContainer>
				)}
				<LabelName>{name}</LabelName>
				{onRemove && (
					<IconContainer left>
						<CrossIconOld
							size={CrossIconOld.SIZE.SMALL}
							color={ColorUtils.getInvertedTextColor(color)}
							onClick={onRemove}
						/>
					</IconContainer>
				)}
			</Content>
		</LabelContainer>
	);
};

Label.propTypes = {
	color: PropTypes.string,
	name: PropTypes.string,
	onClick: PropTypes.func,
	showAI: PropTypes.bool,
	onRemove: PropTypes.func,
};
